import * as React from 'react';
import * as moment from 'moment';
import { ICalendarAppText } from '../../custom/classes/calendar-text';

import { IEvent } from '../../custom/classes/event';
import { ICalendarState, IMonth, IDay } from '../../classes/calendar';
import { connect, Dispatch } from 'react-redux';

import LoadMoreView from 'month-selection-load-more.view';
import { ICalendarAppState } from '../../redux-state';
import { nextMonth } from '../../redux-state/actions/calendar.actions';

interface ILoadMoreExternalProps {
}

interface StateToProps {
    text: ICalendarAppText;
    currDate: moment.Moment;
    lastDate: moment.Moment;
}

interface DispatchToProps {
    goToNextMonth: () => void;
}

export type LoadMoreProps = ILoadMoreExternalProps & StateToProps & DispatchToProps;

export class LoadMoreBase extends React.Component<LoadMoreProps, any> {
    render() {
        return (
            <>
                {
                    this.props.currDate.clone().endOf("month").isSameOrBefore(this.props.lastDate) ? <LoadMoreView {...this.props} /> : null
                }
            </>
        )
    }
}

function mapStateToProps(state: ICalendarAppState, ownProps: ILoadMoreExternalProps): StateToProps {
    return {
        text: state.calendarText,
        currDate: state.calendar.currentDate,
        lastDate: state.calendarSettings.monthsOnCalendar[state.calendarSettings.monthsOnCalendar.length - 1] || moment()
    }
}

function mapDispatchToProps(dispatch: Dispatch): DispatchToProps {
    return {
        goToNextMonth: () => dispatch(nextMonth())
    }
}

export default connect<StateToProps, DispatchToProps>(mapStateToProps, mapDispatchToProps)(LoadMoreBase);